module.exports = __webpack_public_path__ + "img/shortstay-small-image-2.54771894.png";